<ion-button
    [color]="color"
    [class]="'button' + classes ? ' ' + classes : ''"
    [fill]="fill"
    (click)="onButtonClick()"
    [expand]="expand && !displayAsInlineText ? 'block' : undefined"
    [ngClass]="{
        'no-border': borderStyle === 'none',
        'add-vertical-padding': extraVerticalPadding,
        'dashed-border': borderStyle === 'dashed',
        'button-input': borderStyle === 'input',
        'readonly-style': readonly,
        'inline-text-style': displayAsInlineText,
        'inline-text-style--no-transform': inlineTextNoTransform
    }"
    [type]="type"
    [routerLink]="routerLink || []"
    [disabled]="disabled || readonly"
    [href]="href"
    [style.--color]="displayAsInlineText ? inlineTextColorMap[inlineTextColor] || inlineTextColor : undefined"
    [style.font-weight]="displayAsInlineText && inlineTextColor === 'dark' ? '400' : '500'">
    <ng-content></ng-content>
</ion-button>
